import React from 'react';
import { Image, Button, Row, Col, Card, Typography, Spin } from 'antd';
import evmLib from '../evmLib';
import Lib from '../Lib';
import TXAlert from './TXAlert';

const { Title } = Typography;

class NFTOwned extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      connected: false,
      nftId2detail: {}
    };
  }

  async componentDidMount() {
    const blockchainTime = await evmLib.getBlockchainTime();
    this.setState({ blockchainTime });

    await this.refreshData();
  }

  async getSnapshotBeforeUpdate(prevProps, prevState) {
    const prevMetamask = prevProps.metamask;
    const nextMetamask = this.props.metamask;

    if (!prevMetamask && nextMetamask) {
      await this.refreshDataUser();
      return;
    }

    const prevRefreshNum = prevProps.refreshNum;
    const nextRefreshNum = this.props.refreshNum;
    if (prevRefreshNum !== nextRefreshNum) {
      await this.refreshDataUser();
      return;
    }

  }

  componentDidUpdate() {
    return true;
  }

  async refreshData() {
  }

  async refreshDataUser() {
    this.setState({ ownedNFTs: [], busyDataOwned: true, connected: true });

    const wallet = this.props.metamask.getSigner();
    wallet.address = await wallet.getAddress();

    let dataOwned = await evmLib.getOwnedNFTDataUri(wallet, wallet.address);

    const ownedNFTs = [];
    for (let i = 0; i < dataOwned.length; i++) {
      const data = dataOwned[i];
      ownedNFTs.unshift({
        id: data.id.toNumber(),
        metadata: data.metadata
      });
    }

    this.setState({ ownedNFTs, busyDataOwned: false });

    for (let i = 0; i < ownedNFTs.length; i++) {
      const nftId = ownedNFTs[i].id;
      const nftId2detail = this.state.nftId2detail;
      const detail = await evmLib.getOwnedNFTDetail(nftId, wallet);
      nftId2detail[nftId] = detail;
      this.setState({ nftId2detail });
    }
  }

  componentWillUnmount() {
  }

  async claimProfit(nftId, unclaimedTurns) {
    try {
      const metamask = this.props.metamask;
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      const turns = unclaimedTurns;
      let tx = await evmLib.claimNFTProfit(metamask.getSigner(), nftId, turns);
      this.setState({ txHash: tx.hash });
      await tx.wait();

      const nftId2detail = this.state.nftId2detail;
      nftId2detail[nftId] = undefined;
      this.setState({ nftId2detail });
      const detail = await evmLib.getOwnedNFTDetail(nftId, metamask.getSigner());
      nftId2detail[nftId] = detail;
      this.setState({ nftId2detail });

      this.setState({ txStatus: 'confirmed' });
      await this.refreshDataUser();
    } catch (err) {
      this.setState({ txStatus: 'fail' });
    }
  }

  render() {
    const rows = [
    ];

    const owned = this.state.ownedNFTs;
    const nftId2detail = this.state.nftId2detail;

    if (owned && owned.length > 0) {
      for (let i = 0; i < owned.length; i++) {
        const nft = owned[i];
        const detail = nftId2detail[nft.id];
        const row = {
          nftId: nft.id,
          name: nft.metadata.name,
          img: nft.metadata.image,
          unclaimedProfit: false,
          unclaimedTurns: [],
          enable: false
        }

        if (detail) {
          row.unclaimedProfit = evmLib.wei2eth(detail.totalUnclaimed);
          row.unclaimedTurns = detail.unclaimedTurns;
          row.enable = (detail.unclaimedTurns.length > 0);
        }

        rows.push(row);
      }
    }

    let content;
    if (this.state.busyDataOwned) {
      content =
        (
          <div style={{ textAlign: 'center' }}>
            <div>&nbsp;</div>
            <Spin />
            <div>&nbsp;</div>
          </div>
        );
    } else if (rows.length > 0) {
      content = (
        <Row gutter={[8, 8]} justify='center'>
          {rows.map((item, index) => {
            const enable = item.enable;
            const unclaimed = item.unclaimedProfit;
            const img = item.img;
            let line = (<div style={{ textAlign: 'center' }}><Spin /></div>);
            if (unclaimed) {
              line = (<div style={{ textAlign: 'center' }}>Unclaimed Token: {unclaimed} TXT</div>);
            }
            const nftId = item.nftId;
            const unclaimedTurns = item.unclaimedTurns;

            return (
              <Col key={index} xs={24} sm={8} style={{}}>
                <Card type='inner' title={<Title style={{ textAlign: 'center', height: '100%' }} level={5}>{item.name}</Title>}>
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <div style={{ textAlign: 'center' }}>
                        <Image
                          width={128}
                          src={img}
                        />
                      </div>
                    </Col>
                    <Col span={24}>
                      <div>&nbsp;</div>
                      {line}
                      <div>&nbsp;</div>
                      <Button block disabled={!enable} type='primary' onClick={() => this.claimProfit(nftId, unclaimedTurns)}>CLAIM TOKEN</Button>
                    </Col>
                    <Col span={24}>
                      <Button block onClick={() => Lib.openUrl('https://evm.confluxscan.net/nft/0xa70aeb0a2f9d81d3b75e50736791821db6cf6846/' + item.nftId)}>CONFLUXSCAN</Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            );
          })}
        </Row>

      );
    } else {
      content =
        (
          <div style={{ textAlign: 'center' }}>
            <div>&nbsp;</div>
            Traderbot X genesis member. Earn TXT token daily!
            <div>&nbsp;</div>
          </div>
        );
    }

    return (
      <Card title={<Title level={4}>Owned NFTs</Title>} style={{ height: '100%' }} headStyle={{ textAlign: 'center' }}>
        <TXAlert showTxPopup={this.state.showTxPopup} txStatus={this.state.txStatus} txHash={this.state.txHash}
          onBack={() => this.setState({ showTxPopup: false })} />
        {content}
      </Card>
    );
  }

}

export default NFTOwned;
